<template>
  <ObSubnavigation v-if="isWeb && showContentCenterNav" v-bind="subnavigationConf" v-model:active="active"
    @onSwitch="onSwitchContentModule">
    <template #tabEvent>
      <ObPopover 
        ref="contentCenterPop" 
        placement="bottom"
        popContentType="custom"
        customColor="rgba(0, 102, 255, 1)"
        trigger="manual"
        :offset="[0, 22]"
        customRadius="12px"
        :showArrow="!hideContentCenterTip && contentCenterPop.visible"
      >
        <span>{{ $t(`contentCenter.${navList[1].name}`) }}</span>
        <template #custom>
          <div class="cover-tips" v-if="!hideContentCenterTip && contentCenterPop.visible">
            <span>
              {{ $t('shootOnOppo.contentCenterTips') }}
            </span>
            <svg-icon @click="onHideTips" name="icon-delete-round-white"/>
          </div>
        </template>
      </ObPopover>
    </template>
  </ObSubnavigation>
  <!-- <template #tabs>
      <div class="nav-tabs">
      <van-tabs
        v-model:active="active"
        ref="tabsRef"
        color="var(--color-text-primary)"
        title-active-color="var(--color-text-primary)"
        title-inactive-color="var(--color-text-description)"
        :shrink="true"
        :ellipsis="false"
        :animated="false"
        :lazy-render="false"
        :line-width="lineWidth"
        @change="onChangeTab"
        @click-tab="onSwitchContentModule"
      >
        <van-tab
          v-if="navList[0].show" 
          :name="navList[0].name"
          :title="$t(`contentCenter.${navList[0].name}`)"
        />
        
          <van-tab
            v-if="navList[1].show" 
            :name="navList[1].name"
            :title="$t(`contentCenter.${navList[1].name}`)"
          >
            <template #title>
              <ObPopover 
                ref="contentCenterPop" 
                placement="bottom"
                popContentType="custom"
                customColor="rgba(0, 102, 255, 1)"
                trigger="manual"
                :offset="[0, 22]"
                customRadius="12px"
                :showArrow="!hideContentCenterTip && contentCenterPop.visible"
              >
                <span>{{ $t(`contentCenter.${navList[1].name}`) }}</span>
                <template #custom>
                  <div class="cover-tips" v-if="!hideContentCenterTip && contentCenterPop.visible">
                    <span>
                      {{ $t('shootOnOppo.contentCenterTips') }}
                    </span>
                    <svg-icon @click="onHideTips" name="icon-delete-round-white"/>
                  </div>
                </template>
              </ObPopover>
            </template>
          </van-tab>
          
        <van-tab
          v-if="navList[2].show" 
          :name="navList[2].name"
          :title="$t(`contentCenter.${navList[2].name}`)"
        />
      </van-tabs>
      </div>
    </template> -->
  <div class="content-center-nav" v-if="!isWeb && showContentCenterNav">
    <div class="nav-selection" v-if="navList?.filter(i=>i.show).length === 1">
      <span>{{ $t(`contentCenter.${route.name}`) }}</span>
      <div class="content-center-action">
        <SvgIcon v-if="!isOneplus && !isOppoApp" name="icon-share" @click.stop="showShare = true" />
      </div>
    </div>
    <ObPopover v-else ref="selectionRef" placement="bottom" :fitWidth="true">
      <ObPopover ref="contentCenterPop" placement="bottom" popContentType="custom" customColor="rgba(0, 102, 255, 1)"
        trigger="manual" :offset="[-24, 0]" customRadius="12px"
        :showArrow="!hideContentCenterTip && contentCenterPop.visible">
        <div class="nav-selection">
          <div>
            <span>{{ $t(`contentCenter.${navList.find(i => i.name === route.name)?.name}`) }}</span>
            <SvgIcon name="icon-arrow-down" v-if="navList?.length > 1" />
          </div>
          <div class="content-center-action">
            <SvgIcon v-if="!isOneplus && !isOppoApp" name="icon-share" @click.stop="showShare = true" />
          </div>
        </div>
        <template #custom>
          <div class="cover-tips" v-if="!hideContentCenterTip && contentCenterPop.visible">
            <span>
              {{ $t('shootOnOppo.contentCenterTips') }}
            </span>
            <svg-icon @click="onHideTips" name="icon-delete-round-white" />
          </div>
        </template>
      </ObPopover>
      <template #custom>
        <dl class="nav-select-container">
          <dt v-for="item in navList.filter(i => !!i.show)" @click="onSwitchContentModule(item)">
            {{ $t(`contentCenter.${item.name}`) }}
          </dt>
        </dl>
      </template>
    </ObPopover>
  </div>
  <Share v-if="isWeb" v-model="showShare" :bindUrl="shareUrl" />
  <WapShare v-else v-model="showShare" :bindUrl="shareUrl" />
</template>

<script setup>
  import { useRoute } from 'vue-router';
  import { storeToRefs } from 'pinia';
  import { useSystemStore } from '@/stores/system'
  import ObPopover from '../common/obPopover.vue';
  import { getCurrentInstance } from 'vue';


  const route = useRoute()
  const router = useRouter()
  const systemStore = useSystemStore()
  const { proxy } = getCurrentInstance()
  const { isWeb, galleryList, isOneplus, isOppoApp, customSetting } = storeToRefs(systemStore)

  const tabsRef = ref(null)
  const selectionRef = ref({})
  const contentCenterPop = ref({})

  const shareUrl = ref('')
  const active = ref('ambassador')

  const lineWidth = ref(136)

  const showShare = ref(false)
  const hideContentCenterTip = ref(false)

  const subnavigationConf = computed(() => {
    return {
      title: navList.value?.filter(i => i.show).length === 1 ? proxy.$t(`contentCenter.${route.name}`) : 'Content Center',
      tabs: [{
        hidden: !navList.value[0].show,
        name: navList.value[0].name,
        title: proxy.$t(`contentCenter.${navList.value[0].name}`),
      }, {
        hidden: !navList.value[1].show,
        name: navList.value[1].name,
        title: proxy.$t(`contentCenter.${navList.value[1].name}`),
        hasTabEvent:true
      }, {
        hidden: !navList.value[2].show,
        name: navList.value[2].name,
        title: proxy.$t(`contentCenter.${navList.value[2].name}`),
      }],
      buttonList: [{
        text: proxy.$t('share'),
        callback: () => {
          showShare.value = true
        }
      }],
    }
  })


  const navList = computed(() => {
    return customSetting.value?.contentCenterList || []
  })

  const galleryProductName = computed(() => {
    return galleryList.value[0]?.featuredTabNameList[0].value
  })

  const showContentCenterNav = computed(() => {
    return navList.value?.some(i => i.name === route.name)
  })

  // async function onChangeTab(name) {
  //   await nextTick(() => {
  //     lineWidth.value = document.querySelector('.van-tab--active')?.querySelector('.van-tab__text').offsetWidth
  //   })
  //   tabsRef.value?.resize()
  //   console.log(active.value)
  // }

  function onSwitchContentModule({ name }) {
    const routeData = {
      name: name || value
    }
    proxy.$ga('click_content_nav', {
      "button_name": proxy.$t(`contentCenter.${name}`)
    })
    if (name === 'ambassador') {
      Object.assign(routeData, {
        params: {
          id: galleryList.value[0]?.name,
          productId: galleryProductName.value
        }
      })
    }
    router.push(routeData)
    selectionRef.value.visible = false
    onHideTips()
  }

  function onHideTips() {
    contentCenterPop.value.visible = false
    localStorage.setItem('contentCenterTips', false)
    hideContentCenterTip.value = true
  }

  watch(() => [route.name, navList.value], ([val, list]) => {
    if (list?.some(i => i.name === val)) {
      shareUrl.value = location.href
      active.value = val
      setTimeout(() => {
        // isWeb.value && onChangeTab(val)
        if (import.meta.env.VITE_COUNTRY === 'GLOBAL' && (list.length > 1)) {
          hideContentCenterTip.value = !!localStorage.getItem('contentCenterTips')
          contentCenterPop.value.visible = !hideContentCenterTip.value
          setTimeout(() => {
            onHideTips()
          }, 3000)
        }
      }, 500)
    }
  }, {
    immediate: true,
    deep: true
  })

</script>

<style lang="postcss" scoped>
  .content-center-nav {
    position: sticky;
    top: calc(var(--orbit-notice-height, 0px) + var(--orbit-nav-height, 0px));
    z-index: 99;
    display: flex;
    align-items: center;
    height: 52px;
  }
 
  :deep(.van-popover__wrapper){
    height: 100%;
    display: flex;
  }

  .van-tabs {
    /* width: 1200px; */
    margin: 0 auto;

    :deep(.van-tabs__wrap) {
      height: 52px;

      .van-tabs__nav {
        align-items: center;
        height: 52px;
        padding: 0 0 7px 0;
        box-sizing: border-box;

        .van-tabs__line {
          border-radius: 0;
          --van-tabs-bottom-bar-height: 2px;
        }

        .van-tab {
          height: fit-content;
          padding-left: 0;
          padding-right: 0;
          margin: 0 16px;
          color: var(--color-text-description);
          font-size: 16px;
        }

        .van-tabs__line {
          bottom: 0;
        }
      }
    }
  }

  .content-center-action {
    flex-shrink: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;

    :deep(.ob-button) {
      font-size: 12px;
      margin-left: 16px;
    }
  }

  .nav-selection {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;

    span {
      font-family: 'orbit-M';
    }
  }

  .cover-tips {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 328px;
    height: 70px;
    padding: 12px 16px;
    box-sizing: border-box;
    color: #FFF;

    span {
      width: 266px;
    }

    .svg-icon {
      flex-shrink: 0;
      width: 34px;
      height: 34px;
      margin-left: 4px;
    }
  }

  @media screen and (max-width: 1023px) {
    .content-center-nav {
      height: 44px;
      background-color: var(--color-background-primary);
      box-shadow: 0 1px 0 0 var(--color-border-default);
    }

    .nav-selection {
      width: 100vw;
      height: 44px;
      padding: 0 20px;
      box-sizing: border-box;

      div {
        display: flex;
        align-items: center;

        span {
          font-family: 'orbit-M';
        }
      }

      .icon-arrow-down {
        width: 20px;
        height: 20px;
        color: var(--color-text-primary);
      }
    }

    .nav-select-container {
      width: 100vw;
      padding: 0 40px 16px;
      background-color: var(--color-background-primary);
      box-sizing: border-box;

      dt {
        padding: 16px 0;
        margin-bottom: 4px;
        border-bottom: 1px solid var(--color-border-default);

        &:last-child {
          border: none;
        }
      }
    }

    .cover-tips {
      width: 271px;
    }
  }
</style>